var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    [
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.adminContractPartnerDetails.label.name")
                ) +
                "\n      "
            ),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.contractPartnerName,
              callback: function($$v) {
                _vm.contractPartnerName =
                  typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "contractPartnerName"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.adminContractPartnerDetails.label.email")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "email"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.adminContractPartnerDetails.label.domain")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.domain,
              callback: function($$v) {
                _vm.domain = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "domain"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.adminContractPartnerDetails.label.street")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.street,
              callback: function($$v) {
                _vm.street = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "street"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "message.adminContractPartnerDetails.label.streetNumber"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.streetNumber,
              callback: function($$v) {
                _vm.streetNumber = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "streetNumber"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.adminContractPartnerDetails.label.postalCode")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.postalCode,
              callback: function($$v) {
                _vm.postalCode = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "postalCode"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("template", { slot: "label" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "message.adminContractPartnerDetails.label.postOfficeBox"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "rounded-0",
            model: {
              value: _vm.postOfficeBox,
              callback: function($$v) {
                _vm.postOfficeBox = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "postOfficeBox"
            }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-form-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-btn",
                {
                  staticClass: "rounded-0 px-0",
                  attrs: { variant: "link" },
                  on: {
                    click: function($event) {
                      _vm.$emit("onCancel")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("message.adminContractPartnerDetails.btn.back")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", [
            _c("div", { staticClass: "d-flex flex-row" }, [
              _c(
                "div",
                { staticClass: "ml-auto" },
                [
                  _vm.isDeletable
                    ? _c(
                        "b-btn",
                        {
                          attrs: { variant: "danger" },
                          on: {
                            click: function($event) {
                              _vm.$emit("onDelete")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.adminContractPartnerDetails.btn.delete"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "ml-4",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.$emit("onSave")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "message.adminContractPartnerDetails.btn.save"
                            )
                          ) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71e36cdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71e36cdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminContractPartnerForm.vue
// module id = Te+F
// module chunks = 1